import React, { Component } from "react";
import i18next from 'i18next';
/*svg imports */
import personProvider from "../../../../../static/images/personProvider.svg";

import FileUpload from "../../../utils/fileUpdload";

export class FileProviderBSC extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="main-addProvider">
          <div className="header-providers">
            <div className="title">
              <img src={personProvider} className="icon" />
              <p className="p-list">{i18next.t('general.placeholders.upload_file')}</p>
            </div>
            <div className="actions flex-element left-flex report-download">
              <p>{i18next.t('general.placeholders.download_template')}</p>
              <a href={`/static/documents/plantilla_proveedores_bsc.csv`}>CSV</a>
            </div>
          </div>
          <FileUpload postUrl={`/providers/massive`} />
        </div>
      </React.Fragment>
    );
  }
}

export default FileProviderBSC;